export default __webpack_public_path__ + "static/media/02-NIC.f3b943a1.gif";